import { fixtures } from 'tods-competition-factory';

import PARTICIPANT_PRIVACY_POLICY from './PARTICIPANT_PRIVACY_POLICY';
import { ROUND_NAMING_DEFAULT } from './ROUND_NAMING';
import SCORING_USTA from './SCORING_USTA';
import SEEDING_USTA from './SEEDING_USTA';

const { POLICY_POSITION_ACTIONS_UNRESTRICTED } = fixtures.policies;

export default {
  ...SEEDING_USTA,
  ...SCORING_USTA,
  ...PARTICIPANT_PRIVACY_POLICY,
  ...POLICY_POSITION_ACTIONS_UNRESTRICTED,
  ...ROUND_NAMING_DEFAULT,
};
